// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__2-Diw","spin":"Spinner_spin__75KB3","path":"Spinner_path__aA2gA","dash":"Spinner_dash__VmNIp","centerWrap":"Spinner_centerWrap__+2eju"};